import { observer } from 'mobx-react';
import { Flex } from '../../UI/Flex/Flex';
import { Panel } from '../../Panel/Panel';
import { useStore, useStoreUI } from '@assets/model/Store';
import { ScrollPanel } from '../../Panel/ScrollPanel/ScrollPanel';
import { ChatContainer } from '../ChatContainer/ChatContainer';
import { getFirebase } from '@assets/firebase/FirebaseAdapater';
import * as style from './ChatPanel.module.less';
import { useEffect, useRef, useState } from 'react';
import { Button } from 'react-bootstrap';
export const ChatPanel = observer(() => {
    const store = useStore();
    const [inputText, setInputValue] = useState('');
    const ui = useStoreUI();
    const refInput = useRef<HTMLInputElement>(null);

    const ragAPI = store.ragAPI;
    const history = store.reportChatHistory;

    var totalMessages = 0;
    for (const key in history) {
        var msg = history[key];
        totalMessages += 1;

        if (msg.processed) {
            totalMessages += 1;
        }
    }

    const onClickSend = () => {
        if (ui.chatWaitingForResponse) return;

        const input = refInput.current.value;
        if (input.length == 0) return;

        ragAPI.sendMessage(input);

        setInputValue('');
    };

    const waitingForReply = (
        <i>
            <div
                className="spinner-border spinner-border-sm"
                role="status"
                style={{
                    animationDuration: '1.25s',
                    width: '20px',
                    height: '20px'
                }}
            ></div>{' '}
            Send
        </i>
    );

    const sendButtonContent = (
        <i
            className="bi bi-send"
            onClick={() => {
                onClickSend();
            }}
        >
            {' '}
            Send
        </i>
    );
    const sendButton = (
        <Button className={style.sendButton}>
            {ui.chatWaitingForResponse ? waitingForReply : sendButtonContent}
        </Button>
    );

    return (
        <Panel shadow={true} fillCell={true}>
            <Flex direction="column" fillCell={true}>
                {store.showAdminConsole && (
                    <input
                        type="button"
                        value="Clear Chat"
                        style={{
                            position: 'absolute',
                            right: '10px',
                            top: '-100px',
                            zIndex: 100000
                        }}
                        onClick={() => {
                            var areYouSure = window.confirm(
                                '** Clear Chat: Are you sure ?' +
                                    '\r\nReport Name:' +
                                    store.selectedReportId +
                                    '\r\nCompany: ' +
                                    store.query.value('company_name')
                            );

                            if (areYouSure) {
                                const fb = getFirebase();
                                fb.clear_chat(store.selectedReportId);
                            }
                        }}
                    />
                )}

                <div className={style.messages}>
                    <ChatContainer companyId={store.selectedReportId} />
                </div>
                <Flex className={style.inputLineOffset}>
                    <div className={style.input}>
                        <input
                            ref={refInput}
                            type="text"
                            value={inputText}
                            placeholder="Enter a question"
                            autoFocus={true}
                            onKeyDown={e => {
                                if (e.key === 'Enter') {
                                    onClickSend();
                                }
                            }}
                            onChange={e => {
                                setInputValue(e.currentTarget.value);
                            }}
                        ></input>
                    </div>
                    {sendButton}
                </Flex>
            </Flex>
        </Panel>
    );
});
